import { t } from "@lingui/macro";
import { CSSProperties } from "react";

export const DEFAULT_GRAPH_PADDING = 6;

export interface SelectOption {
  value: string;
  label: () => string;
  /** Style for this particular element */
  style?: CSSProperties;
}

export const diagramTools: SelectOption[] = [
  { label: () => t`Mermaid (Recommend)`, value: "mermaid" },
  { label: () => t`Graphviz`, value: "graphviz" },
  { label: () => t`PlantUML`, value: "plantuml" },
  { label: () => t`C4-PlantUML`, value: "c4plantuml" },
  { label: () => t`Seqdiag (Sequence Diagram)`, value: "seqdiag" },
  { label: () => t`Blockdiag (Block Diagram)`, value: "blockdiag" },
  { label: () => t`Actdiag (Activity Diagram)`, value: "actdiag" },
  { label: () => t`D2`, value: "d2" },
  { label: () => t`Diagrams.net (Draw.io)`, value: "diagramsnet" },
  { label: () => t`Excalidraw`, value: "excalidraw" },
  { label: () => t`Nomnoml`, value: "nomnoml" },
  { label: () => t`Flowchart Fun`, value: "flowchart-fun" },
];
